import { HTTPService } from '@lib/infra/HTTPService/HTTPService';
import {
    YOUTUBE_API_KEYS,
    YOUTUBE_VIDEO_API_URL,
    YOUTUBE_CHANNEL_API_URL,
} from '@lib/constants/YOUTUBE';
import {
    YoutubeVideosRequest,
    YoutubeResponse,
    YoutubeVideoItem,
    YoutubeChannelsRequest,
    YoutubeChannelItem,
} from './types';

interface Dependencies {
    httpService: HTTPService;
}

export class YoutubeService {
    private httpService: HTTPService;
    static i: number = 0;
    constructor({ httpService }: Dependencies) {
        this.httpService = httpService;
    }
    // eslint-disable-next-line
    async getYoutubeVideo(data: any, options: any): Promise<any> {
        const res = await this.httpService.get({
            url: '',
            data,
            options,
        });

        return res;
    }

    async getYoutubeVideoById(
        id: string,
    ): Promise<YoutubeResponse<YoutubeVideoItem> | null> {
        const payload: YoutubeVideosRequest = {
            id,
            part: 'snippet',
            maxResults: 50,
            key: YOUTUBE_API_KEYS[YoutubeService.i],
        };
        try {
            const data = await this.httpService.get({
                url: '',
                data: payload,
                options: {
                    baseURL: YOUTUBE_VIDEO_API_URL,
                },
            });
            return data.data;
        } catch (error) {
            if (YoutubeService.i >= YOUTUBE_API_KEYS.length) {
                YoutubeService.i = 0;
                return null;
            }
            YoutubeService.i += 1;
            return await this.getYoutubeVideoById(id);
        }
    }

    async getYoutubeChannelById(
        id: string,
    ): Promise<YoutubeResponse<YoutubeChannelItem> | null> {
        const payload: YoutubeChannelsRequest = {
            id,
            part: 'snippet',
            maxResults: 50,
            key: YOUTUBE_API_KEYS[YoutubeService.i],
        };
        try {
            const data = await this.httpService.get({
                url: '',
                data: payload,
                options: {
                    baseURL: YOUTUBE_CHANNEL_API_URL,
                },
            });
            return data.data;
        } catch (error) {
            if (YoutubeService.i >= YOUTUBE_API_KEYS.length - 1) {
                YoutubeService.i = 0;
                return null;
            }
            YoutubeService.i += 1;
            return await this.getYoutubeChannelById(id);
        }
    }
    async sendNotification() {
        try {
            await this.httpService.post({
                url: '/youtube/notification',
            });
        } catch (error) {
            console.log('Send Youtube Notification error', error);
        }
    }
}
